import clx from 'classnames'
import styles from './Item.css'

const Item = ({ className, children }) => {
  return (
    <p className={clx(styles.item, className)}>
      {children}
    </p>
  )
}

export default Item
